import { intl } from '@fullstory/intl';
import { isNil } from 'lodash';

export const addToDashboardDeniedMessage = intl.formatMessage({
  defaultMessage:
    'You do not have permission to add cards to that dashboard. Only an admin, architect, or owner can take that action.',
  id: 'Z+JvlF',
});

/**
 * Formats a message for the case where the maximum card limit has been reached on a dashboard.
 * @param cardLimit If known at provided, will include in the message.
 */
export const dashboardMaxCardLimitReached = (cardLimit?: number | null) =>
  !isNil(cardLimit)
    ? intl.formatMessage(
        {
          defaultMessage:
            'This dashboard already has the maximum number of cards allowed ({cardLimit}).',
          id: 'U3zcS7',
        },
        { cardLimit },
      )
    : intl.formatMessage({
        defaultMessage: 'This dashboard already has the maximum number of cards allowed.',
        id: '8YiGTR',
      });

export const propertiesFailedToLoadRetry = intl.formatMessage({
  defaultMessage: 'Failed to load properties. Retry?',
  id: 'Wz2vPI',
});
